import getDataPortalDropDown from './getDataPortalDropDown';
import addDataPortal from "./addDataPortal";
import getAllPortals from "./getAllPortals";
import getDetailDataPortal from "./getDetailDataPortal";
import editDataPortal from "./editDataPortal";
import deleteDataPortal from "./deleteDataPortal";

const DataPortal = {
    getDataPortalDropDown,
    addDataPortal,
    getAllPortals,
    getDetailDataPortal,
    editDataPortal,
    deleteDataPortal
};

export default DataPortal;
